export default {
    row: {
        display: "flex",
    },
    card: {
        height: "35px",
        width: "40px"
    },
    divider: {
        width: "1px",
        height: "25px",
        margin: "5px"
    }
}